import Button from '@components/Button';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { ShopResponse } from '@models/shop';
import { ShopOrderStatus, ShopStatus } from '@models/shop/common';
import { useFlow } from '@stackflow/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    shop: ShopResponse;
}

function OrderButton({ shop }:Props) {
    const {
        shopStatus, orderStatus, id, name,
    } = shop;
    const { push, pop } = useFlow();
    const { t } = useTranslation('shopDetail');
    const disabled = orderStatus !== 'OPEN';
    const project = useProject();
    const message = useMemo(() => {
        if (project?.features.orderEnabled) {
            if (shopStatus === 'NOT_USE_APP_ORDER') {
                return t('button.viewMenu');
            }
            return disabled ? t('button.preparing') : t('button.goToOrder');
        }
        return t('button.viewMenu');
    }, [disabled, project, shopStatus, t]);
    if (shopStatus === 'NOT_USE_APP_ORDER') {
        return null;
    }
    return (
        <Container>
            <Button fullWidth
                id='shop-detail-select-shop-button'
                data-shop-id={id}
                data-shop-name={name}
                aria-label='select-shop-button'
                disabled={disabled}
                onClick={() => {
                    pop();
                    push('ItemsActivity', { shopId: id, type: 'ALL' });
                }}>
                {message}
            </Button>
        </Container>
    );
}

const Container = styled.div`
    padding: 16px 18px 20px;
    width: 100%;
    position: absolute;
    right: 0;
    bottom: 16px;
`;

export default OrderButton;
